if (!customElements.get('quick-add-bulk')) {
  customElements.define(
    'quick-add-bulk',
    class QuickAddBulk extends BulkAdd {
      constructor() {
        super();
        this.cart = document.querySelector('cart-drawer');
        this.quantity = this.querySelector('quantity-input');
        this.addEventListener('click', (event) => {
          if (event.target.closest('.qv_cart_btn')) this.onAddBtnClick();
        });
        const debouncedOnChange = debounce((event) => {
          if (parseInt(event.target.value) === 0) {
            this.startQueue(event.target.dataset.index, parseInt(event.target.value));
            if(this.querySelector(".qv_cart_btn")) this.querySelector(".qv_cart_btn").classList.remove("hidden");
            if(this.querySelector(".qv_add_input")) this.querySelector(".qv_add_input").classList.add("hidden");
          } else {
            this.validateQuantity(event);
          }
        }, ON_CHANGE_DEBOUNCE_TIMER);

        this.addEventListener('change', debouncedOnChange.bind(this));
        this.listenForActiveInput();
        this.listenForKeydown();
        this.lastActiveInputId = null;
        const pageParams = new URLSearchParams(window.location.search);
        window.pageNumber = decodeURIComponent(pageParams.get('page') || '');
      }

      onAddBtnClick(){
        const variantId = parseInt(this.dataset.id);
        const minQty = parseInt(this.dataset.min) || 1;
        const quantityDescription = this.dataset.quantityDescription;

        const itemPayload = { id: variantId, quantity: minQty };
        if (quantityDescription) {
          itemPayload.properties = { Quantity: quantityDescription };
        }

        const body = JSON.stringify({
          items: [itemPayload],
          sections: this.getSectionsToRender().map((section) => section.section),
          sections_url: this.getSectionsUrl(),
        });

        fetch(routes.cart_add_url, { ...fetchConfig(), ...{ body } })
          .then((response) => response.text())
          .then((state) => {
            const parsedState = JSON.parse(state);
            const input = this.querySelector('quantity-input input');
            if (input) input.value = minQty;
            if(this.querySelector(".qv_cart_btn")) this.querySelector(".qv_cart_btn").classList.add("hidden");
            if(this.querySelector(".qv_add_input")) this.querySelector(".qv_add_input").classList.remove("hidden");
            this.renderSections(parsedState, []);
            publish(PUB_SUB_EVENTS.cartUpdate, { source: 'quick-add', cartData: parsedState });
          })
          .catch((e) => {
            console.error(e);
          });
      }

      connectedCallback() {
        this.cartUpdateUnsubscriber = subscribe(PUB_SUB_EVENTS.cartUpdate, (event) => {
          const currentQty = parseInt(this.getInput()?.value || 0);
          const variantRemovedFromCart = event.cartData.items && !event.cartData.items.some((item) => item.id === parseInt(this.dataset.id));
          if (
            event.source === 'quick-add' ||
            (variantRemovedFromCart && currentQty === 0) ||
            (event.cartData.variant_id && !(event.cartData.variant_id === parseInt(this.dataset.id)))
          ) {
            return;
          }
          this.onCartUpdate().then(() => {
            this.listenForActiveInput();
            this.listenForKeydown();
          });
        });

        this.variantChangeUnsubscriber = subscribe(PUB_SUB_EVENTS.variantChange, ({ data: { sectionId, variant, html } }) => {
          const parentProductInfo = this.closest('product-info');
          if (!parentProductInfo) return;
          const parentSectionId = parentProductInfo.dataset.originalSection || parentProductInfo.dataset.section;
          if (parentSectionId !== sectionId) return;
          const htmlNode = html?.tagName === 'PRODUCT-INFO' ? html : html?.querySelector?.('product-info');
          if (htmlNode?.dataset?.productId && parentProductInfo.dataset.productId !== htmlNode.dataset.productId) return;
          this.updateForVariant(variant);
        });
      }

      disconnectedCallback() {
        if (this.cartUpdateUnsubscriber) {
          this.cartUpdateUnsubscriber();
        }
        this.variantChangeUnsubscriber?.();
      }

      updateForVariant(variant) {
        if (!variant) return;

        const collectionEl = this.closest('.collection-quick-add-bulk');
        const sectionId = collectionEl?.dataset?.id;
        if (sectionId) this.id = `quick-add-bulk-${variant.id}-${sectionId}`;
        this.dataset.id = variant.id;
        this.dataset.min = variant.quantity_rule?.min || 1;

        const input = this.querySelector('quantity-input input');
        if (input) {
          input.id = `Quantity-${variant.id}`;
          input.dataset.index = variant.id;
          input.dataset.quantityVariantId = variant.id;
          input.name = `updates[${variant.id}]`;
          input.dataset.min = variant.quantity_rule?.min || 1;
        }

        const btn = this.querySelector('.qv_cart_btn');
        const qtyInputEl = this.querySelector('.qv_add_input');

        if (!variant.available) {
          if (btn) { btn.setAttribute('disabled', ''); btn.classList.remove('hidden'); }
          if (qtyInputEl) qtyInputEl.classList.add('hidden');
          return;
        }

        fetch('/cart.js')
          .then(r => r.json())
          .then(cart => {
            const cartItem = cart.items.find(item => item.variant_id === parseInt(variant.id));
            const cartCount = cartItem ? cartItem.quantity : 0;
            if (input) {
              input.value = cartCount;
              input.dataset.cartQuantity = cartCount;
            }
            if (cartCount > 0) {
              if (btn) { btn.removeAttribute('disabled'); btn.classList.add('hidden'); }
              if (qtyInputEl) qtyInputEl.classList.remove('hidden');
            } else {
              if (btn) { btn.removeAttribute('disabled'); btn.classList.remove('hidden'); }
              if (qtyInputEl) qtyInputEl.classList.add('hidden');
            }
          })
          .catch(e => console.error(e));
      }

      getInput() {
        return this.querySelector('quantity-input input');
      }

      selectProgressBar() {
        return this.querySelector('.progress-bar-container');
      }

      listenForActiveInput() {
        if (!this.classList.contains('hidden')) {
          this.getInput()?.addEventListener('focusin', (event) => event.target.select());
        }
        this.isEnterPressed = false;
      }

      listenForKeydown() {
        this.getInput()?.addEventListener('keydown', (event) => {
          if (event.key === 'Enter') {
            this.getInput().blur();
            this.isEnterPressed = true;
          }
        });
      }

      cleanErrorMessageOnType(event) {
        event.target.addEventListener(
          'keypress',
          () => {
            event.target.setCustomValidity('');
          },
          { once: true }
        );
      }

      onCartUpdate() {
        return new Promise((resolve, reject) => {
          if (this.closest('.collection')) {
            fetch(`${this.getSectionsUrl()}?section_id=${this.closest('.collection').dataset.id}`)
              .then((response) => response.text())
              .then((responseText) => {
                const html = new DOMParser().parseFromString(responseText, 'text/html');
                const collectionId = this.closest('.collection').dataset.id;
                const sourceQty = html.querySelector(
                  `#quick-add-bulk-${this.dataset.id}-${collectionId}`
                );
                if (sourceQty) {
                  this.innerHTML = sourceQty.innerHTML;
                  resolve();
                } else {
                  // Switched variant: server renders section with initial variant ID, not current.
                  // Fall back to live cart check to set correct UI state.
                  fetch('/cart.js')
                    .then(r => r.json())
                    .then(cart => {
                      const cartItem = cart.items.find(item => item.variant_id === parseInt(this.dataset.id));
                      const btn = this.querySelector('.qv_cart_btn');
                      const qtyInputEl = this.querySelector('.qv_add_input');
                      const input = this.querySelector('quantity-input input');
                      if (cartItem) {
                        if (input) { input.value = cartItem.quantity; input.dataset.cartQuantity = cartItem.quantity; }
                        if (btn) { btn.removeAttribute('disabled'); btn.classList.add('hidden'); }
                        if (qtyInputEl) qtyInputEl.classList.remove('hidden');
                      } else {
                        if (input) { input.value = 0; input.dataset.cartQuantity = 0; }
                        if (btn) { btn.removeAttribute('disabled'); btn.classList.remove('hidden'); }
                        if (qtyInputEl) qtyInputEl.classList.add('hidden');
                      }
                      resolve();
                    })
                    .catch(e => { console.error(e); reject(e); });
                }
              })
              .catch((e) => {
                console.error(e);
                reject(e);
              });
          }
        });
      }

      updateMultipleQty(items) {
        this.selectProgressBar().classList.remove('hidden');

        const ids = Object.keys(items);
        const body = JSON.stringify({
          updates: items,
          sections: this.getSectionsToRender().map((section) => section.section),
          sections_url: this.getSectionsUrl(),
        });

        fetch(`${routes.cart_update_url}`, { ...fetchConfig(), ...{ body } })
          .then((response) => {
            return response.text();
          })
          .then((state) => {
            const parsedState = JSON.parse(state);
            this.renderSections(parsedState, ids);
            publish(PUB_SUB_EVENTS.cartUpdate, { source: 'quick-add', cartData: parsedState });
          })
          .catch((e) => {
            console.error(e);
          })
          .finally(() => {

            this.selectProgressBar().classList.add('hidden');
            this.requestStarted = false;
          });
      }

      getSectionsToRender() {
        return [
          {
            id: `quick-add-bulk-${this.dataset.id}-${this.closest('.collection-quick-add-bulk').dataset.id}`,
            section: this.closest('.collection-quick-add-bulk').dataset.id,
            selector: `#quick-add-bulk-${this.dataset.id}-${this.closest('.collection-quick-add-bulk').dataset.id}`,
          },
          {
            id: 'cart-icon-bubble',
            section: 'cart-icon-bubble',
            selector: '.shopify-section',
          },
          {
            id: 'cart-icon-quick',
            section: 'cart-icon-quick',
            selector: '.shopify-section',
          },
          {
            id: 'CartDrawer',
            selector: '#CartDrawer',
            section: 'cart-drawer',
          },
        ];
      }

      renderSections(parsedState, ids) {
        const intersection = this.queue.filter((element) => ids.includes(element.id));
        if (intersection.length !== 0) return;
        this.getSectionsToRender().forEach((section) => {
          const sectionElement = document.getElementById(section.id);
          if (
            sectionElement &&
            sectionElement.parentElement &&
            sectionElement.parentElement.classList.contains('drawer')
          ) {
            parsedState.items.length > 0
              ? sectionElement.parentElement.classList.remove('is-empty')
              : sectionElement.parentElement.classList.add('is-empty');

            setTimeout(() => {
              document.querySelector('#CartDrawer-Overlay').addEventListener('click', this.cart.close.bind(this.cart));
            });
          }
          const elementToReplace =
            sectionElement && sectionElement.querySelector(section.selector)
              ? sectionElement.querySelector(section.selector)
              : sectionElement;
          if (elementToReplace && parsedState.sections?.[section.section]) {
            const sectionHtml = new DOMParser()
              .parseFromString(parsedState.sections[section.section], 'text/html')
              .querySelector(section.selector);
            if (sectionHtml) {
              elementToReplace.innerHTML = sectionHtml.innerHTML;
            }
          }
        });

        if (this.isEnterPressed) {
          this.querySelector(`#Quantity-${this.lastActiveInputId}`).select();
        }

        this.listenForActiveInput();
        this.listenForKeydown();
      }
    }
  );
}
